import { SessionDialog } from "../dialogs/session-dialog";
import { IncomingInfoRequest } from "../messages/methods/info";
import { IncomingRequestDelegate } from "../messages/incoming-request";
import { IncomingRequestMessage } from "../messages/incoming-request-message";
import { NonInviteServerTransaction } from "../transactions/non-invite-server-transaction";
import { UserAgentServer } from "./user-agent-server";

/**
 * INFO UAS.
 * @public
 */
export class InfoUserAgentServer extends UserAgentServer implements IncomingInfoRequest {
  constructor(dialog: SessionDialog, message: IncomingRequestMessage, delegate?: IncomingRequestDelegate) {
    super(NonInviteServerTransaction, dialog.userAgentCore, message, delegate);
  }
}
